import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ICON_TYPE, IconModule } from '@spartacus/storefront';
import { I18nModule, WindowRef } from '@spartacus/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { GenSingleConsignmentInfo } from 'src/app/generac/models/cart.model';
import { GenCheckoutService } from 'src/app/generac/services/checkout.service';
import { UserAccountFacade } from '@spartacus/user/account/root';

@Component({
  selector: 'gen-checkout-single-consignment',
  templateUrl: './checkout-single-consignment.component.html',
  imports: [
    CommonModule,
    IconModule,
    I18nModule,
    FormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenCheckoutSingleConsignmentComponent implements OnInit, OnDestroy {
  @Input() shippingGroupName: string;
  @Input() cartCode: string;
  @Input() manufactureGroupID: string;
  @Input() singleConsignmentInfo: GenSingleConsignmentInfo;
  @Input() updateData: Observable<string>;
  @Input() purchaseOrderNumber: string;
  @Output() singleConsignmentInfoData = new EventEmitter();

  iconTypes = ICON_TYPE;
  singleConsignmentInfoState: boolean;
  isServicePartsDisabled: boolean;

  private destroy$ = new Subject();

  constructor(
    protected winRef: WindowRef,
    private checkoutService: GenCheckoutService,
    private userAccountService: UserAccountFacade,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.singleConsignmentInfoState = this.singleConsignmentInfo?.state;
    this.isServicePartsDisabled = !JSON.parse(this.winRef.localStorage.getItem('isServicePartsEnabled'));
    if (this.updateData) {
      this.updateData
        .pipe(takeUntil(this.destroy$))
        .subscribe(manufactureGroupID => manufactureGroupID == this.manufactureGroupID && this.getSingleConsignmentInfoByManufactureGroup(manufactureGroupID));
    }
  }

  getSingleConsignmentInfoByManufactureGroup(manufactureGroupId: string): void {
    this.userAccountService.get().pipe(
      takeUntil(this.destroy$),
      switchMap((user) => this.checkoutService.getCheckoutInfo(
        this.cartCode, user?.uid, this.shippingGroupName, manufactureGroupId
      )),
      tap(info => {
        this.singleConsignmentInfo = info.singleConsignmentInfo;
        this.singleConsignmentInfoState = this.singleConsignmentInfo?.state;
        this.cdr.markForCheck();
      })
    ).subscribe();
  }

  setSingleConsignmentState(val: any): void {
    const body = {
      purchaseOrderNumber: this.purchaseOrderNumber,
      singleConsignmentInfo: {
        state: val?.target?.checked
      }
    };
    this.singleConsignmentInfoData.emit(body.singleConsignmentInfo.state);
    if (!body?.purchaseOrderNumber) return;
    this.userAccountService.get().pipe(
      takeUntil(this.destroy$),
      switchMap((user) => this.checkoutService.setCheckoutInformation(
        body,
        user?.uid,
        this.cartCode,
        this.shippingGroupName,
        this.manufactureGroupID
      ))
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);;
    this.destroy$.complete();
  }
}
